// Copied from ~/workspace/madam/face/zed-sim.js (Zed's face simulation, shared with the show engine) so the
// sales demo can run his real face standalone on imgoingto.party. Re-copy when the original changes.
/* eslint-disable */
// Zed's simulation: everything that decides what his face does, and nothing that draws it. The playground page,
// the show engine (Node) and the chip-served iPad page all run this one file, so every Zed moves the same.
// Works as a plain <script> (window.ZedSim) and as a CommonJS module (require / Node import).
//
//   const zed = ZedSim.createZed({now, rng, P, poses});
//   zed.say({cues, gests, looks, time})      a line: cue timelines plus its clock (seconds into the audio)
//   const s = zed.step(now)                  advance; s = {E, eye, bL, bR, o, gg, hY, hR, dt}
//   zed.fastFrame(s, opts) / zed.cfgFrame(s.E, opts)   the hardware frames (firmware/PROTOCOL.md)
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.ZedSim = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  // The playground's slider defaults (its HTML value= attributes), plus the virtual channels clips tween.
  const DEFAULT_P = {
    fieldCX: 32, fieldCY: 38, fieldRX: 32.5, fieldRY: 56, fieldColor: '#ff2b0a',
    mouthCX: 32, mouthCY: 27, mouthHW: 22, topDepth: 7, bottomDepth: -4,
    teethTop: false, teethBottom: false, teethInset: 0, topSpan: 0.65, topThick: 6, bottomSpan: 1, bottomThick: 4.25,
    teethThresh: 0.1, teethColor: '#ffffff',
    eyeW: 170, eyeTop: 52, eyeBot: 81, scleraColor: '#ff2b0a', irisSize: 0, irisColor: '#ffb03a',
    pupilSize: 56, pupilStretch: 1.7, lidClose: 0,
    browAngle: 20, browSkew: 0, eyeGap: 10, faceLen: 46, noseDrop: 14,
    idle: true, idleHead: false, idleAmt: 1, arousal: 0.2, stageLight: 0,
    dotScale: 0.42, fieldThresh: 0.1, fieldShade: 1, avDelay: 0, gridW: 48, gridH: 16, showGrid: false, showPin: false,
    headRot: 0, headY: 0, gazeBiasX: 0, gazeBiasY: 0, noseFlare: 0,
  };

  const POSE_KEYS = ['fieldCX', 'fieldCY', 'fieldRX', 'fieldRY', 'fieldColor',
    'mouthCX', 'mouthCY', 'mouthHW', 'topDepth', 'bottomDepth',
    'teethTop', 'teethBottom', 'teethInset', 'topSpan', 'topThick', 'bottomSpan', 'bottomThick', 'teethColor',
    'eyeW', 'eyeTop', 'eyeBot', 'scleraColor', 'irisSize', 'irisColor', 'pupilSize', 'pupilStretch', 'lidClose',
    'browAngle', 'browSkew'];
  const MOUTH_KEYS = ['mouthCY', 'mouthHW', 'topDepth', 'bottomDepth', 'topSpan', 'topThick', 'bottomSpan', 'bottomThick'];

  const BASE = {
    fieldCX: 32, fieldCY: 38, fieldRX: 34.5, fieldRY: 56, fieldColor: '#ff2b0a',
    mouthCX: 32, mouthCY: 30.5, mouthHW: 29.5, topDepth: 25.5, bottomDepth: 2,
    teethTop: true, teethBottom: true, teethInset: 0,
    topSpan: 0.65, topThick: 6, bottomSpan: 1, bottomThick: 4.25, teethColor: '#ffffff',
    eyeW: 170, eyeTop: 52, eyeBot: 81, scleraColor: '#ff2b0a',
    irisSize: 0, irisColor: '#ffb03a', pupilSize: 56, pupilStretch: 1.7, lidClose: 0,
    browAngle: 20, browSkew: 0,
  };
  const SEED_POSES = {
    'machine-v1': { ...BASE },
    'rest-scowl': { ...BASE, fieldRX: 32.5, mouthCY: 27, mouthHW: 22, topDepth: 7, bottomDepth: -4, browAngle: 20, teethTop: false, teethBottom: false },
    'sly-smile': { ...BASE, mouthCY: 25, mouthHW: 20, topDepth: -4, bottomDepth: 7, browAngle: 6, browSkew: 10 },
    'v-closed': { ...BASE, mouthCY: 27, mouthHW: 18, topDepth: 2.5, bottomDepth: -1, teethTop: false, teethBottom: false },
    'v-small': { ...BASE, mouthCY: 26, mouthHW: 17, topDepth: 8, bottomDepth: 4 },
    'v-mid': { ...BASE, mouthCY: 25.5, mouthHW: 20, topDepth: 14, bottomDepth: 7 },
    'v-wide': { ...BASE, mouthCY: 25, mouthHW: 24, topDepth: 20, bottomDepth: 11 },
    'v-round': { ...BASE, mouthCY: 26, mouthHW: 9, topDepth: 10, bottomDepth: 9 },
  };

  // Clips: multi-channel choreographed sequences (takes, emotes). Each step: [timeOffsetMs, partialParams | 'REST',
  // tweenDurMs]. 'REST' returns every touched channel to its pre-clip value.
  const CLIPS = {
    // Contempt is unilateral (FACS R12A+R14A) — the brows carry the asymmetry.
    'smirk-smug': [
      [0,    { topDepth: -3, bottomDepth: 5, mouthHW: 17, browSkew: 9, browAngle: 10 }, 220],
      [260,  { lidClose: 0.25, gazeBiasX: 12, gazeBiasY: 6, headRot: 2 }, 300],
      [1900, 'REST', 400],
    ],
    // First look slow, snap-back accent popped in ~1 frame (Warner Bros timing).
    'double-take': [
      [0,    { gazeBiasX: -24, browAngle: 12, mouthHW: 16 }, 120],
      [370,  { gazeBiasX: 0 }, 100],
      [470,  { headRot: -4, browAngle: 26, lidClose: 0.4, pupilSize: 38 }, 125],
      [595,  { gazeBiasX: -20, headRot: 5, headY: -6, browAngle: -22, lidClose: 0,
               eyeTop: 88, eyeBot: 95, pupilSize: 30, mouthHW: 14, mouthCY: 24,
               topDepth: 16, bottomDepth: 13, arousal: 0.9 }, 45],
      [900,  { eyeTop: 70, eyeBot: 88, browAngle: -14, pupilSize: 48, arousal: 0.5 }, 290],
      [1900, 'REST', 350],
    ],
    // Leak -> fight it back -> bigger leak -> caught (fast catch + glance away).
    'suppressed-smile': [
      [0,    { topDepth: 2, bottomDepth: -1, mouthHW: 19 }, 200],
      [300,  { topDepth: -6, bottomDepth: 6 }, 200],
      [500,  { topDepth: 1, bottomDepth: 0 }, 150],
      [650,  { topDepth: -9, bottomDepth: 8, lidClose: 0.15, browAngle: 6 }, 250],
      [900,  { topDepth: -3, bottomDepth: 2, gazeBiasX: 18 }, 150],
      [1600, 'REST', 400],
    ],
    'nod-yes': [
      [0,    { topDepth: -5, bottomDepth: 6, browAngle: 4 }, 130],
      [130,  { headY: 6, headRot: 1 }, 130],
      [260,  { headY: -4 }, 130],
      [390,  { headY: 3 }, 110],
      [500,  { headY: 0, browAngle: -4 }, 200],
      [1000, 'REST', 300],
    ],
    'shake-no': [
      [0,    { headRot: -5, browAngle: 26 }, 110],
      [110,  { headRot: 5 }, 140],
      [250,  { headRot: -3 }, 140],
      [390,  { headRot: 0, topDepth: -3, bottomDepth: 4, browAngle: 12 }, 200],
      [1000, 'REST', 300],
    ],
    // Eyes MUST close; the rhythmic bob loop with mouth pulses is the laugh.
    'laugh': [
      [0,    { browAngle: -10, headRot: -2, mouthCY: 25 }, 120],
      [120,  { headRot: 2, headY: -5, lidClose: 0.95, topDepth: 18, bottomDepth: 12,
               mouthHW: 24, teethTop: true, teethBottom: true, arousal: 0.8 }, 130],
      [250,  { headY: -1, mouthHW: 20 }, 90],
      [430,  { headY: -6, mouthHW: 25 }, 90],
      [610,  { headY: -1, mouthHW: 20 }, 90],
      [790,  { headY: -6, mouthHW: 25 }, 90],
      [950,  { headY: 0, lidClose: 0.2, topDepth: -6, bottomDepth: 6, mouthHW: 19,
               teethTop: false, teethBottom: false, arousal: 0.3 }, 250],
      [1900, 'REST', 350],
    ],
    // Single arched brow, held long and still — the hold is what sells it.
    'skeptic-brow': [
      [0,    { topDepth: -2, bottomDepth: 2, mouthHW: 17 }, 100],
      [100,  { browSkew: 14, browAngle: 4 }, 180],
      [1200, { headRot: 2 }, 200],
      [1900, 'REST', 350],
    ],
    // Deadpan: killing idleAmt kills ALL idle motion — stillness is the joke.
    'deadpan': [
      [0,    { topDepth: 1, bottomDepth: 0, mouthHW: 19, browAngle: 2, browSkew: 0,
               lidClose: 0.1, gazeBiasX: 0, gazeBiasY: 0, idleAmt: 0 }, 100],
      [1300, { lidClose: 0.85 }, 220],
      [1560, { lidClose: 0.1 }, 260],
      [2100, 'REST', 500],
    ],
    // Delight-gasp: BIG pupils + soft round mouth (tiny pupils would read as fear).
    'gasp-delight': [
      [0,    { headY: 2, lidClose: 0.2 }, 80],
      [80,   { eyeTop: 80, eyeBot: 95, lidClose: 0, pupilSize: 62, browAngle: -16,
               mouthHW: 9, mouthCY: 26, topDepth: 8, bottomDepth: 8, headY: -5, arousal: 0.6,
               noseFlare: 1 }, 100],
      [180,  { mouthHW: 20, topDepth: -8, bottomDepth: 9, teethTop: true }, 300],
      [1300, 'REST', 350],
    ],
    'oooooH': [
      [0,    { mouthHW: 9, mouthCY: 26, topDepth: 10, bottomDepth: 9, browAngle: -12, pupilSize: 62 }, 200],
      [260,  { mouthCX: 20 }, 340],
      [780,  { mouthCX: 44 }, 520],
      [1420, { mouthCX: 32 }, 300],
      [1820, 'REST', 320],
    ],
    'eye-roll': [
      [0,    { gazeBiasX: 30, gazeBiasY: 10, lidClose: 0.15 }, 160],
      [220,  { gazeBiasX: 20, gazeBiasY: -38, lidClose: 0.3 }, 300],
      [600,  { gazeBiasX: -24, gazeBiasY: -30, lidClose: 0.45 }, 340],
      [1050, { gazeBiasX: 0, gazeBiasY: 0, lidClose: 0.55, browAngle: 8 }, 300],
      [1550, 'REST', 400],
    ],
  };
  const MOUTH_CHANNELS = new Set(['mouthCX', 'mouthCY', 'mouthHW', 'topDepth', 'bottomDepth',
    'teethTop', 'teethBottom', 'teethInset', 'topSpan', 'topThick', 'bottomSpan', 'bottomThick']);

  // Additive micro-expressions over brows/eyes, envelope-shaped so they rise and release like muscle movements.
  // atk = attack fraction of duration: small = comedic pop, large = felt ease ("snap is comedy, ease is emotion").
  const GESTURES = {
    raise:     { dur: 0.7,  atk: 0.15, ch: { browAngle: -16, pupilSize: 6 } },
    spike:     { dur: 0.5,  atk: 0.1,  ch: { browAngle: 14 } },
    squint:    { dur: 0.9,  atk: 0.35, ch: { lidClose: 0.4, browAngle: 8 } },
    skew:      { dur: 0.8,  atk: 0.25, ch: { browSkew: 18 } },
    dilate:    { dur: 0.8,  atk: 0.3,  ch: { pupilSize: 8 } },
    constrict: { dur: 0.9,  atk: 0.4,  ch: { pupilSize: -11, lidClose: 0.12 } },
    dart:      { dur: 0.35, atk: 0.15, ch: { gazeX: 26 } },
    glance:    { dur: 0.7,  atk: 0.3,  ch: { gazeY: 18, lidClose: 0.15 } },
  };

  const SHAPE_POSE = { A: 'v-closed', B: 'v-small', C: 'v-mid', D: 'v-wide', E: 'v-round', F: 'v-round', X: 'rest-scowl' };
  const THEMES = {
    narrator: { fieldColor: '#1e63ff', scleraColor: '#2f7bff' },
    devil: { fieldColor: '#ff2b0a', scleraColor: '#ff2b0a' },
    madam: { fieldColor: '#ff2e88', scleraColor: '#ff4fa3' },
  };
  const THEME_KEYS = ['fieldColor', 'scleraColor'];
  const DEFAULT_PEOPLE = () => [{ x: -30, y: 9 }, { x: 0, y: 11 }, { x: 30, y: 9 }];

  // ---- Mouth cues from text timing: letters (fallback) or CMU dictionary visemes ----
  const D_VISEME = (() => {
    const m = {};
    for (const c of 'mbp') m[c] = 'A';
    m['a'] = 'D';
    for (const c of 'eiy') m[c] = 'C';
    m['o'] = 'E';
    for (const c of 'uwq') m[c] = 'F';
    for (const c of 'cdfghjklnrstvxz') m[c] = 'B';
    return m;
  })();

  function directCues(chars, times) {
    const cues = []; let prev = null, lastT = -1;
    for (let i = 0; i < chars.length; i++) {
      const c = (chars[i] || '').toLowerCase();
      const shape = '.!?…'.includes(chars[i]) ? 'X' : D_VISEME[c];
      if (!shape) continue;
      const t = times[i];
      if (shape !== prev && t - lastT >= 0.05) { cues.push([+t.toFixed(3), shape]); prev = shape; lastT = t; }
    }
    return cues;
  }

  // G2P lips: CMU dictionary (pre-converted viseme strings, '*' marks vowels) distributed across each word's real
  // time window from the TTS alignment. Unknown words fall back to char-mapping over their own span.
  function g2pCues(chars, times, cmu) {
    if (!cmu) return directCues(chars, times);
    const raw = [];
    let i = 0;
    const isW = c => /[a-z']/.test((c || '').toLowerCase());
    while (i < chars.length) {
      if ('.!?…'.includes(chars[i])) { raw.push([times[i], 'X']); i++; continue; }
      if (!isW(chars[i])) { i++; continue; }
      let j = i;
      while (j < chars.length && isW(chars[j])) j++;
      const word = chars.slice(i, j).join('').toLowerCase().replace(/'/g, '');
      const t0 = times[i], t1 = (times[j - 1] ?? t0) + 0.07;
      const vis = cmu[word];
      if (vis) {
        const units = vis.match(/[A-FX]\*?/g) || [];
        const wTotal = units.reduce((s, u) => s + (u.includes('*') ? 2 : 1), 0);
        let acc = 0;
        for (const u of units) {
          raw.push([t0 + (t1 - t0) * (acc / wTotal), u[0]]);
          acc += u.includes('*') ? 2 : 1;
        }
      } else {
        for (let k = i; k < j; k++) {
          const shape = D_VISEME[(chars[k] || '').toLowerCase()];
          if (shape) raw.push([times[k], shape]);
        }
      }
      i = j;
    }
    raw.sort((a, b) => a[0] - b[0]);
    const cues = []; let prev = null, lastT = -1;
    for (const [t, shape] of raw) {
      if (shape !== prev && t - lastT >= 0.045) { cues.push([+t.toFixed(3), shape]); prev = shape; lastT = t; }
    }
    return cues;
  }

  function lerpHex(a, b, t) {
    const n = s => parseInt(s.slice(1), 16);
    const pa = n(a), pb = n(b);
    const m = sh => Math.round(((pa >> sh) & 255) + (((pb >> sh) & 255) - ((pa >> sh) & 255)) * t);
    return '#' + ((1 << 24) | (m(16) << 16) | (m(8) << 8) | m(0)).toString(16).slice(1);
  }
  const r1 = v => Math.round(v * 10) / 10;
  const r2v = v => Math.round(v * 100) / 100;

  // A seeded generator, for runs that must repeat exactly (tests; the same face on two machines).
  function seededRng(seed = 1) {
    let s = seed >>> 0 || 1;
    return () => { s ^= s << 13; s >>>= 0; s ^= s >> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; };
  }

  function createZed(opts = {}) {
    const now0 = opts.now || (() => (typeof performance !== 'undefined' ? performance.now() : Date.now()));
    const rand = opts.rng || Math.random;
    const P = opts.P || Object.assign({}, DEFAULT_P);
    const onTweenDone = opts.onTweenDone || (() => {});
    const onAnchor = opts.onAnchor || (() => {});
    const onTheme = opts.onTheme || (() => {});

    const z = {
      P, poses: opts.poses || Object.assign({}, SEED_POSES), PEOPLE: DEFAULT_PEOPLE(), anchor: null,
      ES: { gx: 0, gy: 0, tx: 0, ty: 0, nextSac: 0, blinkT: -1 },
      tweens: [], clip: null, activeGests: [], line: null, prevTheme: null,
      speechF: 1, energyPeak: 0.15, rmsBuf: [], browActL: 20, browActR: 20,
      pinImpulse: 0, bgPulse: 0, lastNow: null, eye: null, E: null,
      nextBlinkAt: null, nextThoughtAt: null,
      hw: { seq: 0, muWas: 0, noWas: 0, lastAl: undefined, lastAr: undefined, browWin: [] },
    };

    // Fractal value-noise for pupil size (M4_Eyes model): coarse octaves wander, fine octaves shimmer (hippus).
    const PN = Array.from({ length: 6 }, (_, i) => ({ prev: rand() - 0.5, next: rand() - 0.5, t0: 0, period: 80 * 2 ** i }));

    // Idle life: independent slow sine phases per body part, layered as deltas on top of the base params.
    z.idleOffsets = (now) => {
      if (!P.idle) return null;
      const t = now / 1000, a = P.idleAmt;
      const s = (freq, phase) => Math.sin(t * 2 * Math.PI * freq + phase);
      return {
        headY: s(0.10, 0) * 5 * a,
        headRot: s(0.06, 1) * 0.7 * a,
        fieldCX: s(0.08, 4) * 0.5 * a,
        fieldCY: s(0.14, 2) * 0.8 * a,
        mouthCY: s(0.19, 1) * 0.6 * a,
        mouthHW: s(0.11, 3) * 0.9 * a,
        topDepth: s(0.085, 5) * 0.8 * a,
        pupilX: s(0.05, 2) * 9 * a,
        pupilY: s(0.075, 4) * 5 * a,
        browA: s(0.13, 2.5) * 2.2 * a,
        browD: s(0.021, 5.2) * 0.7 * a,
      };
    };

    z.startBlink = () => {
      if (!z.ES.blink) z.ES.blink = { t0: now0(), dur: 36 + rand() * 36 };
    };

    z.pupilNoise = (now) => {
      if (P.idleAmt <= 0.05) return 0.5;  // deadpan: pupil holds too
      let sum = 0.5;
      PN.forEach((oc, i) => {
        let ph = (now - oc.t0) / oc.period;
        if (ph >= 1) { oc.prev = oc.next; oc.next = rand() - 0.5; oc.t0 = now; ph = 0; }
        sum += (oc.prev + (oc.next - oc.prev) * ph) * 2 ** i / 64;
      });
      return Math.min(1, Math.max(0, sum));
    };

    // Procedural round-display eyes, Uncanny Eyes style: saccade gaze, dilating pupil, lids that sweep the screen.
    z.stepEyes = (now, o, gg) => {
      const ES = z.ES, PEOPLE = z.PEOPLE;
      if (z.anchor != null) {
        // Anchored gaze = smooth pursuit: track the addressee continuously, with micro-saccade jitter and
        // occasional flicks to others layered on top.
        if (now >= ES.nextSac) {
          const others = PEOPLE.filter((_, k) => k !== z.anchor);
          if (others.length && rand() < 0.15) {
            const f = others[Math.floor(rand() * others.length)];
            ES.flick = { x: f.x, y: f.y };
            ES.nextSac = now + 320 + rand() * 380;
          } else {
            ES.flick = null;
            ES.jx = (rand() * 2 - 1) * 5;
            ES.jy = (rand() * 2 - 1) * 3;
            ES.nextSac = now + 600 + rand() * 1800;
          }
        }
        const t = ES.flick || PEOPLE[z.anchor] || { x: 0, y: 8 };
        ES.tx = t.x + (ES.flick ? 0 : ES.jx || 0);
        ES.ty = t.y + (ES.flick ? 0 : ES.jy || 0);
        ES.gx += (ES.tx - ES.gx) * 0.25;
        ES.gy += (ES.ty - ES.gy) * 0.25;
      } else {
        // Two-tier roaming (M4_Eyes): discrete eased micro-fixations between gated big saccades, with
        // main-sequence duration-vs-distance scaling.
        if (!ES.move && now >= ES.nextSac && P.idleAmt > 0.05) {  // deadpan holds gaze
          const big = now - (ES.lastBig || 0) > (ES.bigGap || 0);
          let nx, ny;
          if (big) {
            nx = (rand() * 2 - 1) * 34;
            ny = (rand() * 2 - 1) * 22;
            ES.lastBig = now;
            ES.bigGap = 800 + rand() * 2200;
            if (Math.hypot(nx - ES.gx, ny - ES.gy) > 36) z.startBlink();
          } else {
            nx = ES.gx + (rand() * 2 - 1) * 4.5;
            ny = ES.gy + (rand() * 2 - 1) * 3;
          }
          const dist = Math.hypot(nx - ES.gx, ny - ES.gy);
          ES.move = { x0: ES.gx, y0: ES.gy, x1: nx, y1: ny, t0: now,
                      dur: big ? Math.min(200, 30 + dist * 2.4) : 7 + rand() * 18 };
        }
        if (ES.move) {
          let e = Math.min(1, (now - ES.move.t0) / ES.move.dur);
          e = 3 * e * e - 2 * e * e * e;
          ES.gx = ES.move.x0 + (ES.move.x1 - ES.move.x0) * e;
          ES.gy = ES.move.y0 + (ES.move.y1 - ES.move.y0) * e;
          if (e === 1) {
            ES.move = null;
            ES.nextSac = now + 35 + rand() * 965;
          }
        }
      }

      const gx = Math.max(-64, Math.min(64, (ES.gx + (o ? o.pupilX : 0) + (gg ? gg.gazeX : 0) + P.gazeBiasX) * 1.5));
      const gy = Math.max(-42, Math.min(42, (ES.gy + (o ? o.pupilY : 0) + (gg ? gg.gazeY : 0) + P.gazeBiasY) * 1.4));

      // Complementary lids with lag: upper follows vertical gaze, lower takes up the slack (M4_Eyes tension
      // model); one-pole filter trails the saccade.
      const gN = gy / 42;
      const uT = 1 - Math.max(0, gN) * 0.55 + Math.max(0, -gN) * 0.12;
      const lT = 1 - Math.max(0, -gN) * 0.45 + Math.max(0, gN) * 0.08;
      ES.uo = ES.uo == null ? uT : ES.uo + (uT - ES.uo) * 0.35;
      ES.lo = ES.lo == null ? lT : ES.lo + (lT - ES.lo) * 0.35;

      // Blink: fast close, 40ms FULL-CLOSED HOLD (guarantees ≥1 hardware frame at closure), then 2× slow reopen;
      // multiplied into lid position so a blink from a squint closes from the squint.
      let blinkF = 0;
      if (ES.blink) {
        const el = now - ES.blink.t0;
        const d = ES.blink.dur, hold = 40;
        if (el < d) blinkF = el / d;
        else if (el < d + hold) blinkF = 1;
        else if (el < d + hold + d * 2) blinkF = 1 - (el - d - hold) / (d * 2);
        else ES.blink = null;
      }
      const baseLid = Math.min(1, Math.max(0, P.lidClose + (gg ? gg.lidClose : 0)));
      const lid = 1 - (1 - baseLid) * (1 - blinkF);
      const pupil = Math.max(5, (P.pupilSize + (gg ? gg.pupilSize : 0)) * (0.88 + 0.24 * z.pupilNoise(now)));
      z.eye = { gx, gy, lid, pupil, uo: ES.uo, lo: ES.lo };
      return z.eye;
    };

    // The face's final channel values this instant: base params plus idle deltas, lips scaled by the voice.
    z.computeE = (o) => {
      const E = Object.assign({}, P);
      if (o) {
        E.fieldCX += o.fieldCX; E.fieldCY += o.fieldCY;
        E.mouthCY += o.mouthCY; E.mouthHW += o.mouthHW; E.topDepth += o.topDepth;
      }
      E.topDepth *= z.speechF;
      if (E.bottomDepth > 0) E.bottomDepth *= z.speechF;
      z.E = E;
      return E;
    };

    // Multi-track tweens: a new tween takes ownership of its channels; older tweens keep only their untouched
    // channels. Mouth and face animate freely in parallel (visemes own the mouth while a clip works the brows).
    z.startTween = (to, dur, keys) => {
      const from = {};
      keys.forEach(k => from[k] = P[k]);
      z.tweens.forEach(t => t.keys = t.keys.filter(k => !keys.includes(k)));
      z.tweens = z.tweens.filter(t => t.keys.length);
      z.tweens.push({ from, to, t0: now0(), dur, keys });
    };

    z.stepTween = (now) => {
      z.tweens = z.tweens.filter(t => {
        const u = Math.min(1, (now - t.t0) / t.dur);
        const e = u < 0.5 ? 2 * u * u : 1 - (2 - 2 * u) ** 2 / 2;
        t.keys.forEach(k => {
          const a = t.from[k], b = t.to[k];
          if (typeof b === 'number') P[k] = a + (b - a) * e;
          else if (typeof b === 'boolean') P[k] = u < 0.5 ? a : b;
          else if (typeof b === 'string' && b[0] === '#') P[k] = lerpHex(a, b, e);
          else P[k] = b;
        });
        if (u === 1) { onTweenDone(t.keys); return false; }
        return true;
      });
    };

    z.playClip = (name) => {
      let steps = CLIPS[name];
      if (!steps) return;
      if (z.line) {
        // While speaking, visemes own the mouth: strip mouth channels so any clip plays speech-safe on brows/eyes/head.
        steps = steps
          .map(([t, tgt, d]) => {
            if (typeof tgt !== 'object') return [t, tgt, d];
            const f = {};
            Object.keys(tgt).forEach(k => { if (!MOUTH_CHANNELS.has(k)) f[k] = tgt[k]; });
            return [t, f, d];
          })
          .filter(s => s[1] === 'REST' || Object.keys(s[1]).length);
      }
      const snapshot = {};
      steps.forEach(s => {
        if (typeof s[1] === 'object') Object.keys(s[1]).forEach(k => snapshot[k] = P[k]);
      });
      z.clip = { steps, snapshot, idx: -1, t0: now0() };
    };

    z.stepClip = (now) => {
      const clip = z.clip;
      if (!clip) return;
      const el = now - clip.t0;
      while (clip.idx + 1 < clip.steps.length && clip.steps[clip.idx + 1][0] <= el) {
        clip.idx++;
        const [, target, dur] = clip.steps[clip.idx];
        const sub = target === 'REST' ? clip.snapshot : target;
        z.startTween(sub, dur, Object.keys(sub));
        if (clip.idx === clip.steps.length - 1) { z.clip = null; return; }
      }
    };

    z.setAnchor = (i) => {
      if (i != null && i !== z.anchor) z.startBlink();
      z.anchor = i;
      if (z.anchor != null) z.ES.nextSac = 0;
      onAnchor(i);
    };

    z.triggerGesture = (name, intensity = 1, durScale = 1) => {
      const g = GESTURES[name];
      if (g) z.activeGests.push({ g, i: intensity, d: durScale, t0: now0() });
      z.pinImpulse = Math.min(900, z.pinImpulse + 260 * intensity);
      z.bgPulse = Math.min(1, z.bgPulse + 0.45 * intensity);
    };

    z.gestureOffsets = (now) => {
      const sum = { browAngle: 0, browSkew: 0, pupilSize: 0, lidClose: 0, gazeX: 0, gazeY: 0 };
      z.activeGests = z.activeGests.filter(a => {
        const p = (now - a.t0) / (a.g.dur * 1000 * (a.d || 1));
        if (p >= 1) return false;
        const atk = a.g.atk || 0.5;
        const env = (p < atk ? p / atk : Math.pow(1 - (p - atk) / (1 - atk), 1.4)) * a.i;
        for (const k in a.g.ch) sum[k] += a.g.ch[k] * env;
        return true;
      });
      return sum;
    };

    z.applyShape = (letter, dur) => {
      const pose = z.poses[SHAPE_POSE[letter]];
      if (!pose) return;
      const sub = {};
      MOUTH_KEYS.forEach(k => { if (pose[k] !== undefined) sub[k] = pose[k]; });
      sub.teethTop = pose.teethTop; sub.teethBottom = pose.teethBottom;
      z.startTween(sub, dur, Object.keys(sub));
    };

    z.applyTheme = (name) => {
      z.restoreTheme();
      const theme = THEMES[name];
      if (!theme) return;
      z.prevTheme = {};
      THEME_KEYS.forEach(k => z.prevTheme[k] = P[k]);
      Object.assign(P, theme);
      onTheme(THEME_KEYS);
    };

    z.restoreTheme = () => {
      if (!z.prevTheme) return;
      Object.assign(P, z.prevTheme);
      onTheme(THEME_KEYS);
      z.prevTheme = null;
    };

    // A line starts: its cue timelines and its clock. line = {cues, gests?, looks?, time: () => seconds into the
    // audio} (or audio: anything with currentTime). Extra fields ride along for the caller.
    z.say = (line) => {
      z.line = Object.assign({ gests: [], looks: [] }, line, { idx: -1, gidx: -1, lidx: -1 });
      return z.line;
    };

    // The line is over. A cached line (playLine) flushes only its end-button cues — timed near/after the final
    // sound — and lets go of the addressee; overdue mid-line gestures are stale acting and are discarded.
    z.endLine = ({ duration = null, release = false } = {}) => {
      const line = z.line;
      const rest = line && duration != null ? line.gests.slice(line.gidx + 1).filter(g => g[0] >= duration - 0.6) : [];
      z.line = null;
      z.applyShape('X', 120);
      if (release) { z.restoreTheme(); z.setAnchor(null); }
      rest.forEach(([, gname, intensity, dscale]) => {
        if (gname.startsWith('clip:')) z.playClip(gname.slice(5));
        else z.triggerGesture(gname, intensity || 1, dscale || 1);
      });
    };

    z.stepLine = () => {
      const line = z.line;
      if (!line) return;
      // Lookahead compensates tween time; avDelay compensates speaker latency so shapes land when the sound arrives.
      const clock = line.time ? line.time() : line.audio.currentTime;
      const t = clock + 0.07 - P.avDelay / 1000;
      let idx = line.idx;
      while (idx + 1 < line.cues.length && line.cues[idx + 1][0] <= t) idx++;
      if (idx !== line.idx) {
        line.idx = idx;
        z.applyShape(line.cues[idx][1], 55);
        if (line.cues[idx][1] === 'X' && idx > 0 && idx < line.cues.length - 1) z.startBlink();
      }
      while (line.gidx + 1 < line.gests.length && line.gests[line.gidx + 1][0] <= t) {
        line.gidx++;
        const [, name, intensity, durScale] = line.gests[line.gidx];
        if (name.startsWith('clip:')) z.playClip(name.slice(5));
        else z.triggerGesture(name, intensity || 1, durScale || 1);
      }
      while (line.lidx + 1 < line.looks.length && line.looks[line.lidx + 1][0] <= t) {
        line.lidx++;
        const who = line.looks[line.lidx][1];
        z.setAnchor(who < 0 ? null : who);
      }
    };

    // The voice's loudness right now (RMS of the samples, any consistent scale): lips open with it while he speaks.
    z.level = (rms, now = now0()) => { if (z.line) z.rmsBuf.push([now, rms]); };

    // One tick of his life. Returns everything a renderer or the hardware needs this instant.
    z.step = (now = now0()) => {
      if (z.lastNow == null) z.lastNow = now;
      if (z.nextBlinkAt == null) { z.nextBlinkAt = now + 1800; z.nextThoughtAt = now + 6000; }
      const dt = Math.min(0.05, (now - z.lastNow) / 1000);
      z.lastNow = now;

      // Life between lines: a blink every 2.5–8 s; rare small gestures (the Machine has private opinions).
      if (now >= z.nextBlinkAt) {
        if (!z.line && P.idleAmt > 0.05) z.startBlink();
        z.nextBlinkAt = now + 2500 + rand() * 5500;
      }
      if (now >= z.nextThoughtAt) {
        if (!z.line && P.idle && P.idleAmt > 0.05)
          z.triggerGesture(['dart', 'glance', 'squint', 'skew'][Math.floor(rand() * 4)], 0.6 + rand() * 0.3);
        z.nextThoughtAt = now + 9000 + rand() * 11000;
      }

      z.stepClip(now);
      // Live loudness rides on top of phoneme shapes: shape from the cues, intensity from the audio energy now.
      if (z.line && z.rmsBuf.length) {
        while (z.rmsBuf.length > 1 && z.rmsBuf[0][0] < now - P.avDelay - 60) z.rmsBuf.shift();
        let rms = z.rmsBuf[0][1];
        for (const [tt, vv] of z.rmsBuf) {
          if (tt <= now - P.avDelay) rms = vv;
          else break;
        }
        z.energyPeak = Math.max(rms, z.energyPeak * Math.pow(0.5, dt / 3));
        const norm = Math.min(1, rms / z.energyPeak);
        z.speechF += (0.7 + 0.55 * norm - z.speechF) * Math.min(1, dt * 18);
      } else {
        z.speechF += (1 - z.speechF) * Math.min(1, dt * 6);
      }
      if (!z.line) z.rmsBuf.length = 0;
      z.stepLine();
      z.stepTween(now);
      z.pinImpulse *= Math.pow(0.5, dt / 0.6);
      z.bgPulse *= Math.pow(0.5, dt / 0.45);

      const o = z.idleOffsets(now);
      const gg = z.gestureOffsets(now);
      const hY = ((o && P.idleHead) ? o.headY : 0) + P.headY;
      const hR = ((o && P.idleHead) ? o.headRot : 0) + P.headRot;
      const bLt = P.browAngle + P.browSkew + (o ? o.browA + o.browD : 0) + gg.browAngle + gg.browSkew;
      const bRt = P.browAngle - P.browSkew + (o ? o.browA - o.browD : 0) + gg.browAngle - gg.browSkew;
      // Shared servo plant: the sim shows (and transmits) what a 180°/s servo can actually do — screens carry the
      // snap, brows arrive as follow-through.
      const browStep = 180 * dt;
      z.browActL += Math.max(-browStep, Math.min(browStep, bLt - z.browActL));
      z.browActR += Math.max(-browStep, Math.min(browStep, bRt - z.browActR));
      const eye = z.stepEyes(now, o, gg);
      const E = z.computeE(o);
      return { E, eye, bL: z.browActL, bR: z.browActR, o, gg, hY, hR, dt };
    };

    // The fast frame his hardware renders, 30 times a second (firmware/PROTOCOL.md "f"). opts: browHold (pin the
    // brows at 20), manual {l, r} (servo test override), mustache (0–3), nose (bool).
    z.fastFrame = (s, opts = {}) => {
      const E = s && s.E, ey = s && s.eye;
      if (!E || !ey) return null;
      const hw = z.hw;
      const f = {
        t: 'f', q: (hw.seq = (hw.seq + 1) & 0xFFFF),
        fx: r1(E.fieldCX), fy: r1(E.fieldCY),
        mx: r1(E.mouthCX), my: r1(E.mouthCY), hw: r1(E.mouthHW),
        td: r1(E.topDepth), bd: r1(E.bottomDepth),
        tt: E.teethTop ? 1 : 0, tb: E.teethBottom ? 1 : 0,
        al: r1(s.bL), ar: r1(s.bR),
        gx: r1(ey.gx), gy: r1(ey.gy), ld: r2v(ey.lid), ps: r1(ey.pupil),
        et: r1(E.eyeTop), eb: r1(E.eyeBot),
        fc: E.fieldColor.slice(1), sc: E.scleraColor.slice(1),
      };
      if (opts.browHold) { f.al = 20; f.ar = 20; }
      if (opts.manual) { f.al = +opts.manual.l; f.ar = +opts.manual.r; }
      // Anomaly tripwire: the servo plant can't legally jump more than ~6°/frame.
      if (hw.lastAl !== undefined) {
        const dA = Math.abs(f.al - hw.lastAl), dR = Math.abs(f.ar - hw.lastAr);
        if ((dA > 6.5 || dR > 6.5 || !isFinite(f.al) || !isFinite(f.ar)) && opts.warn)
          opts.warn('BROW TX ANOMALY ' + JSON.stringify({ al: f.al, ar: f.ar, dAl: dA, dAr: dR, seq: f.q }));
      }
      hw.lastAl = f.al; hw.lastAr = f.ar;
      hw.browWin.push([f.al, f.ar]);
      if (hw.browWin.length > 30) hw.browWin.shift();
      // Muzzle-art keys ride only while active (plus one zero-frame on turn-off, since firmware latches absent
      // keys) — keeps the frame inside the 240-byte ESP-NOW budget when the features are idle.
      const mu = +opts.mustache || 0;
      const no = opts.nose ? 1 : 0;
      if (mu || hw.muWas) f.mu = mu;
      if (no || hw.noWas) { f.no = no; f.nf = no ? r2v(P.noseFlare) : 0; }
      hw.muWas = mu; hw.noWas = no;
      return JSON.stringify(f);
    };

    // The config frame (firmware/PROTOCOL.md "c"): on connect and every 2 s. opts.brightness: panel brightness.
    z.cfgFrame = (E = z.E || P, opts = {}) => JSON.stringify({
      t: 'c', v: 1, q: (z.hw.seq = (z.hw.seq + 1) & 0xFFFF),
      fx: r1(E.fieldCX), frx: r1(E.fieldRX), fry: r1(E.fieldRY),
      fc: E.fieldColor.slice(1),
      ti: r1(E.teethInset), ts: r2v(E.topSpan), tk: r1(E.topThick),
      bs: r2v(E.bottomSpan), bk: r1(E.bottomThick), tc: E.teethColor.slice(1),
      sh: r2v(E.fieldShade), ew: r1(E.eyeW), et: r1(E.eyeTop), eb: r1(E.eyeBot),
      pt: r2v(E.pupilStretch), sc: E.scleraColor.slice(1),
      is: r1(E.irisSize), ic: E.irisColor.slice(1),
      bn: +(opts.brightness || 80),
    });

    return z;
  }

  return {
    createZed, seededRng, DEFAULT_P, POSE_KEYS, MOUTH_KEYS, BASE, SEED_POSES, CLIPS, MOUTH_CHANNELS, GESTURES,
    SHAPE_POSE, THEMES, THEME_KEYS, D_VISEME, directCues, g2pCues, lerpHex,
  };
});
